import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { EmployeeFilterParam } from "./useGetAllEmployees";
import { queryKeys } from "../queryKeys";
import { Employee } from "../../../types/Employee";
import { Event } from "../../../types/Event";
import CustomAxios from "../../../utility/customAxios";

type EventEmployee = {
  employees: Employee[];
  event_employees: {
    employee_uuid: string;
    event: Event;
  }[];
}

export type UseGetScheduledEmployeeEventsParams = {
  date_range: string[];
  filters?: EmployeeFilterParam & { with_events?: boolean };
};

export type UseGetScheduledEmployeeEventsProps = {
  params?: UseGetScheduledEmployeeEventsParams;
  enabled?: boolean;
};

const fetchtScheduledEmployeeEvents = async (params?: UseGetScheduledEmployeeEventsParams) => {
  const response = await CustomAxios.get<EventEmployee>(`employees/schedule`, { params });
  const { data } = response;
  return data;
};

export function useGetScheduledEmployeeEvents({ params, enabled = true }: UseGetScheduledEmployeeEventsProps) {
  const queryKey: any = [queryKeys.allEmployees, 'schedule', params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchtScheduledEmployeeEvents(params),
    placeholderData: keepPreviousData,
  });
  return query;
}
